<template lang="pug">
v-text-field(
  v-bind="$attrs"
  v-on="$listeners"
  :rules="hostRules"
  label='Power BI Workspace Id'
  data-track="workspaceId"
  dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputHost extends Vue {
  hostRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Workspace Id is required'];
}
</script>
